//? imports
import styles from "./MenuItem.module.css";
const MenuItem = (props) => {
  const { desc, img, price, title } = props;

  return (
    <section className={styles["menu-item"]}>
      <div
        className={styles["image-container"]}
        style={{ backgroundImage: `url(${img})` }}
      ></div>
      <div className={styles["item-container"]}>
        <div id={styles["title-price"]}>
          <h3>{title}</h3>
          <h3>{"$" + price}</h3>
        </div>
        <hr />
        <p id={styles["description"]}>{desc}</p>
      </div>
    </section>
  );
};

export default MenuItem;
